import {BrowserModule} from '@angular/platform-browser';
import {
  NgModule,
} from '@angular/core';
import {Routes, RouterModule} from "@angular/router";
import {LocationStrategy, HashLocationStrategy} from '@angular/common';

import {AppComponent} from './app.component';
import {HeaderComponent} from './components/header/header';
import {FooterComponent} from './components/footer/footer';
import {LoginComponent} from './pages/login/login';
import {
  RecoverPasswordComponent
} from './pages/recoverpassword/recoverpassword';
import {SignUpComponent} from './pages/signup/signup';
import {MainComponent} from './pages/main/main';
import {HomeComponent} from './pages/home/home';
import {LoginFormComponent} from './components/login-form/login-form.component';
import {
  RegisterFormComponent
} from './components/register-form/register-form.component';
import {MessageComponent} from './components/messages/message.component';
import {ResetPasswordComponent} from './pages/resetpassword/resetpassword';
import {ConfirmComponent} from './pages/confirm/confirm';
import {ProfileComponent} from './pages/profile/profile';

import {InitComponent} from './pages/init/init';

import {AuthGuardService as AuthGuard} from './services/auth-guard.service';
import {UserService} from './services/user.service';
import {RecaptchaModule} from 'ng-recaptcha';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {AppsComponent} from './pages/apps/apps';
import { RequestOptions } from '@angular/http';
import { CustomRequestOptions } from './services/custom-request-options';
import { NgSelectModule } from '@ng-select/ng-select';

const routes: Routes = [
  {path: '', component: InitComponent, pathMatch: 'full'},
  {path: 'home', component: HomeComponent, canActivate: [AuthGuard]}, {
    path: 'login',
    component: LoginComponent,
    resolve: {login: AuthGuard},
  },
  {path: 'signup', component: SignUpComponent},
  {path: 'confirmation', component: ConfirmComponent},
  {path: 'recoverPassword', component: RecoverPasswordComponent},
  {path: 'resetPassword', component: ResetPasswordComponent},
  {path: 'apps', component: AppsComponent, canActivate: [AuthGuard]}, {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {path: '**', component: HomeComponent, canActivate: [AuthGuard]}
];


@NgModule({
  declarations: [
    AppComponent, HeaderComponent, FooterComponent, SignUpComponent,
    LoginComponent, RecoverPasswordComponent, ResetPasswordComponent,
    MainComponent, HomeComponent, LoginFormComponent, RegisterFormComponent,
    MessageComponent, AppsComponent, InitComponent, ConfirmComponent, ProfileComponent
  ],
  imports: [
    BrowserModule, RouterModule.forRoot(routes),
    RecaptchaModule.forRoot(), FormsModule, ReactiveFormsModule,
    HttpClientModule, NgSelectModule
  ],
  providers: [AuthGuard, UserService, { provide: RequestOptions, useClass: CustomRequestOptions }],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts